import { ActionType, createAction } from "typesafe-actions";

import SavedAddress from "@mapmycustomers/shared/types/SavedAddress";

import { SavedLocationNamingCardState } from "./SavedLocationsUiState";

export const showSavedLocationCard = createAction("@savedLocationsUi/card/show")<{
  id: SavedAddress["id"];
}>();

export const hideSavedLocationCard = createAction("@savedLocationsUi/card/hide")<void>();

export const showSavedLocationNamingCard = createAction(
  "@savedLocationsUi/namingCard/show"
)<SavedLocationNamingCardState>();

// With an id, it closes only that row's card: a late request of a replaced card can't close the newer one
export const hideSavedLocationNamingCard = createAction("@savedLocationsUi/namingCard/hide")<{
  id: SavedAddress["id"];
} | void>();

export type SavedLocationsUiActions = ActionType<
  | typeof hideSavedLocationCard
  | typeof hideSavedLocationNamingCard
  | typeof showSavedLocationCard
  | typeof showSavedLocationNamingCard
>;
